'use strict'
// Expose smoothscroll-polyfill in the browser.
module.exports = require('smoothscroll-polyfill')
